// Initialize theme object if it doesn't exist
window.theme = window.theme || {};

class CustomTabs extends HTMLElement {
  constructor() {
    super()
    this.tabHeadings = this.querySelectorAll('.js-itbh')
    this.tabContents = this.querySelectorAll('.js-itb')
    this.init()
  }
  init() {
    let container = this
    let contents = this.tabContents || document.querySelectorAll('.js-itb')
    if (this.tabHeadings) {

      this.tabHeadings.forEach(heading => {
        heading.addEventListener('click', () => {
          let currentActiveElement = container.querySelector('.js-itbh.active')
          currentActiveElement.classList.remove('active')
          const dataTarget = heading.dataset.target
          heading.classList.add('active')
          contents.forEach(content => {
            if (content.dataset.targetId != dataTarget) {
              content.classList.remove('active')
            } else {
              content.classList.add('active')
            }
          })
        })
      })
    }
  }
}

if (!window.customElements.get('custom-tabs'))
  window.customElements.define('custom-tabs', CustomTabs)

const customSwiperInitEvent = "swiperElementLoaded";

function initFeaturedProductsSlider() {
  const ccfSlider = new Swiper('.featured-products-slider-wrapper', {
    navigation: {
      nextEl: '.fpb-button-next',
      prevEl: '.fpb-button-prev',
    },
    slidesPerView: 1.3,
    spaceBetween: 16,
    breakpoints: {
      768: {
        slidesPerView: 4,
      }
    }
  });
}

function initRibbon() {
  const ccfSlider = new Swiper('.ribbon-section__swiper', {
    loop: true, 
    slidesPerView: 'auto',       
    speed: 6000, 
    autoplay: {
      delay: 0, 
      disableOnInteraction: false, 
    },
    freeMode: true, 
    freeModeMomentum: false, 
    spaceBetween: 32,
    breakpoints: {      
      992: {
        slidesPerView: 6,
      }
    }
  });
}

function initCCFSlider() {
  const ccfSlider = new Swiper('.collection-color-filder-silder', {
    navigation: {
      nextEl: '.npb-button-next',
      prevEl: '.npb-button-prev',
    },
    slidesPerView: 5,
    spaceBetween: 12,
    breakpoints: {
      768: {
        slidesPerView: 11
      }
    }
  })
}
function productMediaSlider() {

  var productMediaGallery = new Swiper('.main-product-gallery', {
    slidesPerView: 1,
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },
    on: {
      slideChange: function () {
        updateActiveSlide(this.activeIndex);
      }
    }
  });

  var swiperThumbs = new Swiper('.main-product-gallery-thumbs', {
    slidesPerView: 6,
    slideToClickedSlide: true,
    spaceBetween: 10,
    mousewheel: {
      releaseOnEdges: true,
    },
    navigation: {
      nextEl: '.thumbs-button-next.swiper-button-next',
    },
    breakpoints: {
      0: {
        slidesPerView: 4,
        direction: 'horizontal',
      },
      1000: {
        direction: 'vertical',
      },
    },
    on: {
      init: function () {
        createCustomBullets(this);
      },
      scroll: function () {
        updateActiveSlide(this.activeIndex);
      }
    },
  });

  let previousIndex = 0;

  const thumbsContainer = document.querySelector(".main-product-gallery-thumbs");
  if (!thumbsContainer) {
    return;
  }

  const thumbsSlides = Array.from(thumbsContainer.querySelectorAll(".swiper-slide"));

  if (thumbsSlides.length) {
    thumbsSlides[0].classList.add("selected");
  }

  function updateActiveSlide(index) {

    thumbsSlides.forEach((slide) => slide.classList.remove("selected"));
    const bullets = document.querySelectorAll(".custom-swiper-bullet");

    if (thumbsSlides[index]) {
      thumbsSlides[index].classList.add("selected");
    }
    bullets.forEach((b) => b.classList.remove("active"));
    if (bullets[index]) {
      bullets[index].classList.add("active");
    }
    productMediaGallery.slideTo(index);
    swiperThumbs.slideTo(index);
    previousIndex = index;
  }

  thumbsSlides.forEach((slide, index) => {
    slide.addEventListener("click", () => {
      updateActiveSlide(index);
      swiperThumbs.slideTo((previousIndex >= index) ? index - 1 : index);
    });
  });

  function createCustomBullets(swiper) {
    const paginationContainer = document.querySelector(".custom-swiper-pagination");
    if (!paginationContainer) {
      return;
    }

    paginationContainer.innerHTML = "";
    swiper.slides.forEach((_, index) => {
      const bullet = document.createElement("span");
      bullet.classList.add("custom-swiper-bullet");
      bullet.dataset.index = index;
      bullet.addEventListener("click", () => {
        updateActiveSlide(index);
      });
      paginationContainer.appendChild(bullet);
    });

    const bullets = document.querySelectorAll(".custom-swiper-bullet");
    if (bullets.length) {
      bullets[0].classList.add("active");
    }
  }

  // productMediaGallery.controller.control = prodyctMediaGalleryThumbs;
  // prodyctMediaGalleryThumbs.controller.control = productMediaGallery;
}
const initSlider = () => {
  initFeaturedProductsSlider()
  initRibbon()
  // initCCFSlider()

  if (theme.template.indexOf('product') != -1) {
    productMediaSlider()
  }
}
document.addEventListener('swiperElementLoaded', initSlider())


document.addEventListener('DOMContentLoaded', () => {
  setTimeout(() => {
    function subscription() {
      const oneTime = document.querySelector('.onetime-radio');
      if (oneTime) {
        const onTimePrice = oneTime?.querySelector('.rc-radio__label')?.innerHTML.replace('One time purchase', '');
        document.querySelector('.onetime-radio .rc-radio__label').innerHTML = `<span class>One time purchase</span><span class="rc-radio__price">${onTimePrice}</span>`;
      }
    } subscription();
  }, 1000)


  function videoTogglePlay() {
    document.querySelectorAll('.video-toggle-button').forEach(element => {
      element.addEventListener('click', function () {
        const video = this.closest('.video-section').querySelector('.video-section__media video');
        if (video.paused == false) {
          video.pause();
          video.firstChild.nodeValue = 'Play';
          this.innerHTML = `<svg xmlns="http://www.w3.org/2000/svg" width="56" height="56" viewBox="0 0 56 56" fill="none"><circle cx="28" cy="28" r="27.5" fill="#606161" fill-opacity="0.2" stroke="white"/><path d="M40.3067 28C40.3075 28.3134 40.2271 28.6217 40.0735 28.8948C39.9198 29.168 39.6981 29.3967 39.4298 29.5588L22.806 39.7283C22.5257 39.8999 22.2047 39.9936 21.8762 39.9997C21.5476 40.0058 21.2233 39.924 20.9369 39.7629C20.6532 39.6043 20.4168 39.3729 20.2522 39.0927C20.0875 38.8124 20.0005 38.4934 20 38.1684V17.8316C20.0005 17.5066 20.0875 17.1876 20.2522 16.9073C20.4168 16.6271 20.6532 16.3957 20.9369 16.2371C21.2233 16.076 21.5476 15.9942 21.8762 16.0003C22.2047 16.0064 22.5257 16.1001 22.806 16.2717L39.4298 26.4412C39.6981 26.6033 39.9198 26.832 40.0735 27.1052C40.2271 27.3783 40.3075 27.6866 40.3067 28Z" fill="white"/></svg>`
        } else {
          video.play();
          video.firstChild.nodeValue = 'Pause';
          this.innerHTML = `<svg xmlns="http://www.w3.org/2000/svg" width="56" height="56" viewBox="0 0 56 56" fill="none"><circle cx="28" cy="28" r="27.5" fill="#606161" fill-opacity="0.2" stroke="white"/><rect x="19" y="17" width="5" height="22" rx="2.5" fill="white"/><rect x="32" y="17" width="5" height="22" rx="2.5" fill="white"/></svg>`;
        }
      })
    })
  } videoTogglePlay();


  function cardBlockLink() {
    const sourceLink = document.querySelectorAll('.card-block-link');
    sourceLink.forEach(element => {
      element.addEventListener('click', function () {
        window.location.href = this.dataset.link;
      })
    })
  } cardBlockLink();
})

document.querySelectorAll('.accordion .summary').forEach(aHeading => {
  aHeading.addEventListener('click', () => {
    const accordionContainer = aHeading.closest('.accordion').querySelector('.accordion__content')
    const openedHeading = document.querySelector('.accordion .summary[aria-expend="true"]')
    if (aHeading.getAttribute('aria-expend') == 'false') {
      accordionContainer.style.height = `${accordionContainer.scrollHeight}px`
      aHeading.setAttribute('aria-expend', true)
      if (openedHeading) {
        const preaccordionContainer = openedHeading.closest('.accordion').querySelector('.accordion__content')
        openedHeading.setAttribute('aria-expend', false)
        preaccordionContainer.style.height = "0"
      }
    } else {
      aHeading.setAttribute('aria-expend', false)
      accordionContainer.style.height = `0`
    }
  })
})

function handleProductSwiper(productCard) {
  const swiperContainer = productCard.querySelector('.swiper-container');
  if (!swiperContainer || swiperContainer.classList.contains('swiper-initialized')) {
    return;
  }
  let swiperInstance = null;

  function initializeSwiper() {
    if (window.innerWidth <= 768) {
      if (!swiperInstance) {
        swiperInstance = new Swiper(swiperContainer, {
          slidesPerView: 1,
          grabCursor: true,
          pagination: {
            el: '.swiper-pagination',
            clickable: true,
          },
        });
      }
    } else {
      if (swiperInstance) {
        swiperInstance.destroy(true, true);
        swiperInstance = null;
      }
    }
  }
  initializeSwiper();
  window.addEventListener('resize', initializeSwiper);
}

function handleModalProductSwiper(productCard) {
  const swiperContainer = productCard.querySelector('.swiper-container');
  if (!swiperContainer || swiperContainer.classList.contains('swiper-initialized')) {
    return;
  }
  let swiperInstance = null;

  function initializeSwiper() {
    if (!swiperInstance) {
      swiperInstance = new Swiper(swiperContainer, {
        slidesPerView: 1,
        grabCursor: true,
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        },
        loop: true,
      });
    }
  }
  initializeSwiper();
  window.addEventListener('resize', initializeSwiper);
}

function buildMediaModal (productCard) {
  const templateMedia = productCard.querySelector('template.modal-plans__clone-media');

  if (templateMedia) {
    const templateContent = templateMedia.content.cloneNode(true);
    const modalPlansMedia = productCard.querySelector('.modal-plans__media .card__media');
    const containerId = productCard.dataset.containerId;
    const productGrid = productCard.closest('#product-grid');
    const alternativeContext = productGrid?.querySelector(`[data-id="${containerId}"]`);

    if (modalPlansMedia) {
      modalPlansMedia.appendChild(templateContent);
      handleModalProductSwiper(productCard.querySelector('.modal-plans'));
    } else if (alternativeContext) {
      alternativeContext.querySelector('.modal-plans__media .card__media').appendChild(templateContent);
      handleModalProductSwiper(alternativeContext);
    } else {
      console.warn('Element ".modal-plans__media .card__media" not found');
      return;
    }

  } else {
    return;
  }
}

function setupSubscriptionPlanChangeListener (productCard) {
  let modalOnCard = productCard.querySelector('.modal-plans');
  if (!modalOnCard) {
    const containerId = productCard.dataset.containerId;
    const productGrid = productCard.closest('#product-grid');
    modalOnCard = productGrid?.querySelector(`[data-id="${containerId}"]`);
  }

  const subscriptionSelect = modalOnCard.querySelector('.modal-plans__selling-plan-dropdown');
  const priceDisplay = modalOnCard.querySelector('.modal-plans__option--subscription .modal-plans__label-price');
  const planIdInput = modalOnCard.querySelector('.product-selling-plan-variant-id');

  if (!subscriptionSelect || !priceDisplay || ! planIdInput) {
    console.warn(`setup Subscription Plan select element not found`);
    return;
  }

  subscriptionSelect.addEventListener('change', (event) => {
    modalOnCard.querySelector('.modal-plans__radio--control-subscription').checked = true;

    const selectedOption = event.target.selectedOptions[0];

    if (selectedOption) {
      const planType = selectedOption.dataset.type;
      const planAdjustment = parseFloat(selectedOption.dataset.adjustment);
      const basePrice = parseFloat(selectedOption.dataset.price);

      const priceDisplaySale = priceDisplay.querySelector('.modal-plans__price-item--sale');

      if (priceDisplaySale) {
        if (planType === 'percentage') {
          const discountAmount = basePrice * (planAdjustment / 100);
          const salePrice = basePrice - discountAmount;
          priceDisplaySale.textContent = formatPrice(salePrice);
        } else if (planType === 'fixed_amount') {
          const salePrice = basePrice - planAdjustment;
          priceDisplaySale.textContent = formatPrice(salePrice);
        } else if (planType === 'price') {
          priceDisplaySale.textContent = formatPrice(planAdjustment);
        }
      }

      const planId = selectedOption.value;
      if (planId !== undefined) {
        planIdInput.value = planId;
      }
    }

    function formatPrice(price) {
      if (typeof price === 'number') {
        return `$${(price / 100).toFixed(2)}`;
      } else {
        return '$0.00';
      }
    }
  });
}

function setupSendProductToCart (productCard) {
  let btnToCArt = productCard.querySelector('.quick-add__submit--subscription');
  if (!btnToCArt) {
    const containerId = productCard.dataset.containerId;
    const productGrid = productCard.closest('#product-grid');
    const alternativeContext = productGrid?.querySelector(`[data-id="${containerId}"]`);
    btnToCArt = alternativeContext.querySelector('.quick-add__submit--subscription');
  }

  if (btnToCArt) {
    btnToCArt.addEventListener('click', (event) => {
      const variantInput = btnToCArt.previousElementSibling;
      const sellingPlanInput = variantInput ? variantInput.previousElementSibling : null;

      let variantId;
      let sellingPlanId;

      if (variantInput && variantInput.classList.contains('product-variant-id')) {
        variantId = variantInput.value;
      } else {
        console.warn('Sibling input with class .product-variant-id not found before the button.');
        return;
      }

      if (sellingPlanInput && sellingPlanInput.classList.contains('product-selling-plan-variant-id')) {
        sellingPlanId = sellingPlanInput.value;
      } else {
        console.warn('Sibling input with class .product-selling-plan-variant-id not found before the .product-variant-id input.');
        return;
      }

      fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json'
        },
        body: JSON.stringify({
          id: variantId,
          quantity: 1,
          selling_plan: sellingPlanId
        })
      })
      .then(response => {
        if (!response.ok) throw new Error('Error al agregar al carrito');
        return response.json();
      })
      .then(data => {
        console.log('Producto con suscripción agregado al carrito:', data);
        if (window.Rebuy && window.Rebuy.SmartCart) {
          window.Rebuy.SmartCart.show();
        }
      })
      .catch(error => {
        console.error('Error:', error);
      });
    })
  } else {
    console.warn('.quick-add__submit--subscription button not found within productCard.');
  }
}

// Handles one-time purchase ATC in the modal popup, opening Rebuy Smart Cart on success
function setupOneTimePurchase(productCard) {
  let modalContext = productCard.querySelector('.modal-plans');
  if (!modalContext) {
    const containerId = productCard.dataset.containerId;
    const productGrid = productCard.closest('#product-grid');
    modalContext = productGrid?.querySelector(`[data-id="${containerId}"]`);
  }

  const oneTimeBtn = modalContext?.querySelector('.modal-plans__botton-no-subcription [type="submit"]');
  if (!oneTimeBtn) return;

  oneTimeBtn.addEventListener('click', (event) => {
    event.preventDefault();

    const variantInput = modalContext.querySelector('.modal-plans__botton-no-subcription .product-variant-id');
    if (!variantInput) {
      console.warn('One-time purchase: .product-variant-id input not found.');
      return;
    }

    fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      },
      body: JSON.stringify({ id: variantInput.value, quantity: 1 })
    })
    .then(response => {
      if (!response.ok) throw new Error('Error adding to cart');
      return response.json();
    })
    .then(() => {
      if (window.Rebuy && window.Rebuy.SmartCart) {
        window.Rebuy.SmartCart.show();
      }
    })
    .catch(error => {
      console.error('Error:', error);
    });
  });
}

function eventsModalProductoOnPLP(productCard) {
  const openerButtons = productCard.querySelectorAll('.modal-plans__open-button');

  if (openerButtons.length === 0) {
    return;
  } else {
    openerButtons.forEach(opener => {
      opener.addEventListener('click', () => {
        buildMediaModal(productCard);
        setupSubscriptionPlanChangeListener(productCard);
        setupSendProductToCart(productCard);
        setupOneTimePurchase(productCard);
      });
    });
  }
}

window.theme.initLoadMore = function (loadMoreElement = null) {
  let currentPage = 1;
  const productGrid = document.querySelector('#product-grid');
  const loadMoreButton = loadMoreElement || document.getElementById('load-more');
  const lazyLoadTrigger = loadMoreElement || document.getElementById('lazy-load');

  if (!loadMoreButton && !lazyLoadTrigger) return;

  // Desconectar observers anteriores si existen
  if (window.theme.lazyLoadObserver) {
    window.theme.lazyLoadObserver.disconnect();
    window.theme.lazyLoadObserver = null;
  }

  const totalPageNumber = parseInt((loadMoreButton || lazyLoadTrigger).dataset.totalPageNum);
  const collectionHandle = (loadMoreButton || lazyLoadTrigger).dataset.collectionHandle;

  function loadMoreProducts() {
    currentPage++;
    if (currentPage > totalPageNumber) return;

    // Construir URL con filtros actuales si existen
    let url = `/collections/${collectionHandle}?page=${currentPage}`;
    
    // Si hay filtros activos, incluirlos en la URL
    if (typeof FacetFiltersForm !== 'undefined' && FacetFiltersForm.searchParamsPrev) {
      const currentFilters = FacetFiltersForm.searchParamsPrev;
      // Remover parámetros de paginación existentes y agregar el nuevo page
      const cleanedFilters = currentFilters.replace(/&?page=\d+/g, '');
      url = `/collections/${collectionHandle}?page=${currentPage}&${cleanedFilters}`;
      console.log('🔄 Loading more products with filters:', url);
    } else {
      console.log('🔄 Loading more products without filters:', url);
    }

    fetch(url)
      .then(response => response.text())
      .then(data => {
        const parser = new DOMParser();
        const doc = parser.parseFromString(data, 'text/html');
        const newProducts = doc.querySelector('#product-grid')?.querySelectorAll('.grid__item');

        if (newProducts && newProducts.length > 0) {
          newProducts.forEach((product, index) => {
            product.classList.add('fade-in-up'); // animation
            product.style.animationDelay = `${index * 500}ms`; // delay 
            productGrid.appendChild(product);
            handleProductSwiper(product);
            eventsModalProductoOnPLP(product);
          });

          // hide load more button if there are not more products
          if (currentPage >= totalPageNumber && loadMoreButton) {
            loadMoreButton.style.display = 'none';
          }
        } else {
          if (loadMoreButton) loadMoreButton.style.display = 'none';
        }
      })
      .catch(error => {
        console.error('Error loading more products:', error);
        if (loadMoreButton) loadMoreButton.style.display = 'none';
      });
  }

  // load more button
  if (loadMoreButton) {
    loadMoreButton.addEventListener('click', loadMoreProducts);
  }

  // Lazy load 
  if (lazyLoadTrigger && 'IntersectionObserver' in window) {
    window.theme.lazyLoadObserver = new IntersectionObserver((entries) => {
      if (entries[0].isIntersecting && currentPage < totalPageNumber) {
        loadMoreProducts();
      }
    }, {
      rootMargin: '0px 0px 100px 0px', // load before 
    });
    window.theme.lazyLoadObserver.observe(lazyLoadTrigger);
    
    // Fallback: Si después de 2 segundos no se ha cargado más contenido y hay más páginas, forzar carga
    setTimeout(() => {
      if (currentPage === 1 && totalPageNumber > 1) {
        loadMoreProducts();
      }
    }, 2000);
  }
};


document.addEventListener('DOMContentLoaded', function () {
  const productGrid = document.querySelector('#product-grid');

  if (productGrid) {
    const productCards = productGrid.querySelectorAll('.product-card-wrapper');
    productCards.forEach(product => {
      handleProductSwiper(product);
      eventsModalProductoOnPLP(product);
    });
  }

  window.theme.initLoadMore();
});


document.addEventListener('DOMContentLoaded', function () {
  window._shipScout = window._shipScout || [];
  _shipScout.push(async function (response) {
    if(!response.variant === 'B'){
      return;
    }
    console.log('variant b');
    var thresholdCents = (window.Shopify && Shopify.currency && Shopify.currency.rate) ? response.freeShippingThresholdCents * Shopify.currency.rate : response.freeShippingThresholdCents;
    var currencyFormat = ShipScoutGetCurrency();
    var thresholdAmount = ShipScoutFormatMoney(thresholdCents, currencyFormat);

    const announcementMessages = document.querySelectorAll('.announcement-bar__message .animate-underline');
    announcementMessages.forEach(function (message) {
      if (message.textContent.includes('Free Shipping on U.S. Orders $75+')) {
        message.innerHTML = message.innerHTML.replace('$75', thresholdAmount);
      }
    });

    let orderText = 'for orders below $74.99, and free for orders $75';
    let belowOrderPrice = ShipScoutFormatMoney(((thresholdCents / 100) - 0.01).toFixed(2), currencyFormat);

    const accordionContents = document.querySelectorAll('.accordion__content p');
    accordionContents.forEach(function (content) {
      if (content.textContent.includes(orderText)) {
        content.innerHTML = content.innerHTML.replace(orderText, `for orders below ${belowOrderPrice}, and free for orders ${thresholdAmount}`);
      }
    });

    const sarContents = document.querySelectorAll('.sar-content');
    sarContents.forEach(function (content) {
      if (content.textContent.includes(orderText)) {
        content.innerHTML = content.innerHTML.replace(orderText, `for orders below ${belowOrderPrice}, and free for orders ${thresholdAmount}`);
      }
    });

    const rebuyObserver = new MutationObserver(()=> {
      const rebuyCartShipping = document.querySelector('.rebuy-cart__progress-bar-prompt');
      if(rebuyCartShipping) {
        if (rebuyCartShipping.textContent.includes('free shipping')) {
          rebuyCartShipping.innerHTML = rebuyCartShipping.innerHTML.replace('$75.00', thresholdAmount);       
          rebuyCartObserver.observe(rebuyCartShipping, { childList: true });
          updateRebuyProgressBar(thresholdCents);
        }     
        rebuyObserver.disconnect();
      }
    });
    rebuyObserver.observe(document.body, {childList: true, subtree: true});

    const rebuyCartObserver = new MutationObserver(mutationsList => {
      mutationsList.forEach(mutation => {
        if (mutation.type === 'childList') {
          updateRebuyProgressBar(thresholdCents);
        }
      });
    });
  });
});

async function getCartProducts() {
  try {
    const response = await fetch('/cart.js');
    if (!response) throw new Error('Error fetching Shopify Cart');
    const cartData = await response.json();
    return cartData.items;
  } catch (error) {
    console.error('Fetch error:', error);
    return [];
  }
}

async function updateRebuyProgressBar(thresholdCents) {
  const rebuyCartShipping = document.querySelector('.rebuy-cart__progress-bar-prompt');
  const rebuyCartProgressBar = document.querySelector('.rebuy-cart__progress-bar-meter-fill');
  if (!rebuyCartShipping || !rebuyCartProgressBar) return;
  let totalPrice = 0;
  const products = await getCartProducts();
  products.forEach(product => {
    totalPrice += (product.final_line_price / 100)
  });
  thresholdCents = thresholdCents / 100;
  if (totalPrice < thresholdCents) {
    let price = thresholdCents - totalPrice;
    rebuyCartShipping.innerHTML = `You are $${price} away from free shipping`;
    rebuyCartProgressBar.style.width = Math.ceil((totalPrice / thresholdCents) * 100) + '%';
  } else {
    rebuyCartShipping.innerHTML = `🎉 Congrats! You've unlocked <b>FREE SHIPPING!</b>`;
    rebuyCartProgressBar.style.width = '100%';
  }
}